import { Group } from '@mantine/core';
import { IAutomationSendEmail } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import P3Medium from 'components/typography/P3Medium';
import P3Regular from 'components/typography/P3Regular';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';

/**
 * The automation preview for send-email automation.
 */
export default function SendEmailAutomationPreview({ data }: { data: IAutomationSendEmail }) {
  return (
    <>
      <Group spacing={4}>
        <P3Medium>E-mail:</P3Medium>
        <P3Regular>
          <InputMention prefix="Podľa poľa" name={data.email} />
        </P3Regular>
      </Group>

      <span>&#x7c;</span>

      <Group spacing={4}>
        <P3Medium>Predmet:</P3Medium>
        <P3Regular>{data.subject}</P3Regular>
      </Group>

      <span>&#x7c;</span>

      <Group spacing={4}>
        <P3Medium>PDF príloha:</P3Medium>
        <P3Regular>{data.attachPdf ? 'Áno' : 'Nie'}</P3Regular>
      </Group>
    </>
  );
}
